























































































import { Component, Vue } from "vue-property-decorator";
import Header from "@/components/Header.vue";
import Pdf from "@/components/Pdf.vue";
import Menu from "@/components/Menu.vue";
import NextPrevBtn from "@/components/NextPrevBtn.vue";
import Footer from "@/components/Footer.vue";
@Component({
  components: {
    Pdf,
    Header,
    Menu,
    NextPrevBtn,
    Footer,
  },
})
export default class GeneralCultureGoFurther extends Vue {
  protected nxtprevGeneralCultureGoFurther = {
    BoolPrev: true,
    BoolNext: false,
    PrevImage: "/thumbnail6.png",
    NextImage: "",
    PrevLink: "/CultureGenerale/Importance",
    NextLink: "",
  };
  protected pdfBook = [
    {
      PdfLink: "/pdf_culture/Book.pdf",
      PdfDownload: "FichePedagogique",
      TxtPdf: "Le livre comme outil pédagogique",
    },
  ]
}
